import React, { Component } from 'react';
import classSet from 'react-classset';
import { lory } from 'lory.js';
import Cookies from 'js-cookie';
import { getComponentContent } from '../../helpers.js';
const closeIcon = process.env.REACT_APP_IMAGES_ROOT + 'x.svg';
const slide1Image = process.env.REACT_APP_IMAGES_ROOT + 'skin-sleep.svg';
const slide2Image = process.env.REACT_APP_IMAGES_ROOT + 'sleep-scents.svg';
const slide3Image = process.env.REACT_APP_IMAGES_ROOT + 'sound-sleep.svg';

class Intro extends Component {

  constructor() {
    super();
    this.state ={
      currentSlide: 0
    }
    this.handleSlideClick = this.handleSlideClick.bind(this);
    this.renderSlide = this.renderSlide.bind(this);
    this.renderDot = this.renderDot.bind(this);
    this.closeIntro = this.closeIntro.bind(this);
    this.content = getComponentContent('Intro');
  }

  componentWillMount() {
    Cookies.set('dermalogica-sleep-cocoon-intro', 'true');
  }

  componentDidMount() {
    const slider = document.querySelector('.js_slider');
    this.lory = lory(slider, {
      enableMouseEvents: true
    });
    const self = this;
    slider.addEventListener('after.lory.slide', event => {
      self.setState({currentSlide: self.lory.returnIndex()});
      if (self.lory.returnIndex() === 3) {
        this.closeIntro();
      }
    });
  }

  componentWillUnmount() {
    this.lory.destroy();
  }

  handleSlideClick() {
    const idx = this.lory.returnIndex();
    if (idx === 2) {
      this.closeIntro();
    } else {
      this.lory.next();
    }
  }

  closeIntro() {
    this.props.closeModal();
  }

  renderSlide(header, desc, img, idx) {
    const slideClasses = classSet({
      'ssc__slider__slide': true,
      'ssc__slider__slide--landscape': this.props.orientation === 'landscape'
    });
    return (
      <li key={idx} className={slideClasses} onClick={this.handleSlideClick}>
        <div className="ssc__intro__slide-content">
          <img src={img} alt={header} />
          <h2 className="with-hr">{header}</h2>
          <p>{desc}</p>
        </div>
      </li>
    );
  }

  renderDot(idx) {
    const dotClasses = classSet({
      'ssc__intro__dots__dot': true,
      'ssc__intro__dots__dot--highlighted': idx <= this.state.currentSlide
    });
    return (
      <div key={idx} className={dotClasses}></div>
    );
  }

  render() {

    const cta = this.props.touch ? this.content.tapCta : this.content.clickCta;

    return (

      <div className="ssc__intro">

        <div className="ssc__intro__inner">
          
          <div className="ssc__intro__close" onClick={this.closeIntro}>
            <img className="ssc__intro__close-icon" src={closeIcon} alt="close" />
            <span className="ssc__intro__close-copy">{this.content.skipIntro}</span>
          </div>
          
          <div className="ssc__intro__dots">
            {this.renderDot(0)}
            {this.renderDot(1)}
            {this.renderDot(2)}
          </div>

          <h3 className="ssc__intro__footer ssc__text-uppercase">{cta}</h3>

        </div>

        <div className="ssc__slider js_slider">
          <div className="ssc__slider__frame js_frame">
              <ul className="ssc__slider__slides js_slides">
                {this.renderSlide(this.content.slide1Header, this.content.slide1Description, slide1Image, 0)}
                {this.renderSlide(this.content.slide2Header, this.content.slide2Description, slide2Image, 1)}
                {this.renderSlide(this.content.slide3Header, this.content.slide3Description, slide3Image, 2)}
                <li className="ssc__slider__slide"></li>
              </ul>
          </div>
        </div>

      </div>

    );

  }

}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js